// src/components/DesignerLogin.js
import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const DesignerLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
  
    if (!email || !password) {
      toast.error("Please enter both email and password.");
      return;
    }
  
    setLoading(true);
  
    const formData = new URLSearchParams();
    formData.append('email', email);
    formData.append('password', password);
  
    try {
      const response = await axios.post(
        'https://software.tabtrips.com/api/login_user.php',
        formData.toString(),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );
  
      const { data } = response;
  
      if (data.status === 'success') {
        const { security_token, role, walletAmount, walletHash } = data;
  
        // ✅ Store all user auth + financial info
        localStorage.setItem('authToken', security_token);
        localStorage.setItem('userRole', role);
        localStorage.setItem('walletAmount', walletAmount.toFixed(2));
  
        // 🔐 Store hash for later verification
        // localStorage.setItem('walletHash', walletHash);
        localStorage.setItem("email", email);
  
        toast.success('Login successful!');
        window.location.href = '/';
      } else {
        toast.warn(data.message || 'Login failed.');
      }
    } catch (error) {
      toast.error('An error occurred during login.');
      console.error("Login Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(to bottom right, #1a202c, #2d3748)',
      padding: '1rem',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    }}>
      <div style={{
        backgroundColor: '#fff',
        borderRadius: '1rem',
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
        width: '100%',
        maxWidth: '400px',
        padding: '2rem'
      }}>
        <h2 style={{
          fontSize: '1.875rem',
          fontWeight: '700',
          textAlign: 'center',
          marginBottom: '1.5rem',
          color: '#2d3748'
        }}> Login</h2>

        <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div>
            <label htmlFor="email" style={{ fontWeight: '500', marginBottom: '0.25rem', display: 'block' }}>Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              style={{
                width: '100%',
                padding: '0.75rem',
                borderRadius: '0.5rem',
                border: '1px solid #cbd5e0',
                fontSize: '1rem'
              }}
            />
          </div>

          <div>
            <label htmlFor="password" style={{ fontWeight: '500', marginBottom: '0.25rem', display: 'block' }}>Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  borderRadius: '0.5rem',
                  border: '1px solid #cbd5e0',
                  fontSize: '1rem'
                }}
              />
              <span onClick={() => setShowPassword(!showPassword)} style={{
                position: 'absolute',
                right: '1rem',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#6b7280'
              }}>
                {showPassword ? '🙈' : '👁️'}
              </span>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              backgroundColor: loading ? '#94a3b8' : '#3182ce',
              color: '#fff',
              padding: '0.75rem',
              borderRadius: '0.5rem',
              fontWeight: '600',
              fontSize: '1rem',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <p style={{ marginTop: '1.5rem', textAlign: 'center', fontSize: '0.875rem', color: '#a0aec0' }}>
          &copy; {new Date().getFullYear()} TabTrips Software - Portal
        </p>
      </div>
    </div>
  );
};

export default DesignerLogin;
